<template>
  <div class="col-md-4 d-none d-md-block d-lg-block d-xl-block bg-blue">
    <div class="row min-height--100vh align-items-center">
      <!-- <icon :icon="`a-white`" :width="30" :height="30" class="al-logo-main mb-4"></icon> -->

      <div class="col-md-10 offset-md-1 text-center">
        <h1 class="t-700 d-block t-white">AcademicLabs</h1>
        <span class="t-xxlr t-400 t-white">We organise & connect the world of science to accelerate your R&D pipeline</span>
        <br class="mb-4" />
        <!-- <icon v-if="isLogin" :icon="`dashboard`" class="my-5"></icon>
        <icon v-if="isRegister" :icon="`dashboard`" class="my-5"></icon> -->
        <div class="speech-bubble">
          <p class="t-600 mb-0">
            “I sincerely like it. <span class="t-blue-dark">I’m not using PubMed at all anymore.</span> It is so convenient having all sort of different databases in a single one stop solution, it saves me a lot of efforts and time. It’s now even <span class="t-blue-dark">my start site in Chrome</span>. To find literature, researchers, companies, etc.”
          </p>
        </div>
        <span class="t-white t-700 mb-4">
          Scientific Director at top 10 Pharma Company
        </span>
        <div class="speech-bubble">
          <p class="t-600 mb-0">
            “Just <span class="t-blue-dark">one month in</span> and we already got <span class="t-blue-dark">promising partner meetings scheduled with preclinical startups we would not have met otherwise</span>. Using AcademicLabs has made our <span class="t-blue-dark">market analysis</span> much <span class="t-blue-dark">more efficient and targeted, saving us a lot of time</span> and resulting in more promising partner meetings. We are really happy with our choice.”
          </p>
        </div>
        <span class="t-white t-700 mb-4">
          Michele Farisco, International Marketing Director at Biogem.it (Research Institute & CRO)
        </span>
        <br />
        <router-link
          v-if="showExploreCTA"
          :to="{ name: 'searchHome' }" class="btn btn-large btn-secondary t-600 px-4 my-4">
          Start exploring
        </router-link>

        <!-- <p class="t-white">We bring transparency in the scientific arena to revolutionize research partnering.</p> -->
      </div>
    </div>
  </div>
</template>

<script>
// import Icon from '@/components/shared/Icon'

export default {
  name: 'rightSideText',
  components: {
    // Icon
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    isRegister: {
      type: Boolean,
      default: false
    },
    showExploreCTA: {
      type: Boolean,
      default: true
    }
  }
}
</script>
